import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";
import { Divider } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexPieStatisticsCard from "examples/Cards/StatisticsCards/ComplexPieStatisticsCard";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import {
  getOverallSupplierStats,
  // getStatsByAge,
  getStatsNewOrdersPerMonth,
  getStatsClientsJoinedPerMonth,
} from "actions/statsActions";

function Dashboard() {
  const dispatch = useDispatch();
  // const [chartStatsByAge, setChartStatsByAge] = useState([]);
  const [chartOrders, setChartOrders] = useState([]);
  const [chartComplaints, setChartComplaints] = useState([]);
  const [chartTransactions, setChartTransactions] = useState([]);

  const overallSupplierStats = useSelector(
    (state) => state.overallSupplierStats
  );
  const { supplierStatsOverall } = overallSupplierStats;

  // const statsByAge = useSelector((state) => state.statsByAge);
  // const { ageStats } = statsByAge;

  const statsClientsJoinedPerMonth = useSelector(
    (state) => state.statsClientsJoinedPerMonth
  );
  const { clientsJoinedPerMonth } = statsClientsJoinedPerMonth;

  const statsNewOrdersPerMonth = useSelector(
    (state) => state.statsNewOrdersPerMonth
  );
  const { newOrdersPerMonth } = statsNewOrdersPerMonth;

  useEffect(() => {
    dispatch(getOverallSupplierStats());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(getStatsByAge());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getStatsClientsJoinedPerMonth());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getStatsNewOrdersPerMonth());
  }, [dispatch]);

  // useEffect(() => {
  //   let label = [];
  //   let data = [];
  //   ageStats?.map((item, index) => {
  //     label?.push(item?._id);
  //     data?.push(item?.count);
  //   });
  //   setChartStatsByAge({
  //     labels: label,
  //     datasets: { label: "Clients by Age Group", data: data },
  //   });
  // }, [dispatch, ageStats?.length]);

  useEffect(() => {
    setChartOrders(
      supplierStatsOverall?.orderStatusStats?.map((item, index) => ({
        id: index,
        value: item?.statuses?.percentage,
        label: item?.statuses?.count + " " + item?.statuses?.status,
      }))
    );
  }, [dispatch, supplierStatsOverall]);

  useEffect(() => {
    setChartComplaints(
      supplierStatsOverall?.complaintStatusStats?.map((item, index) => ({
        id: index,
        value: item?.statuses?.percentage,
        label: item?.statuses?.count + " " + item?.statuses?.status,
      }))
    );
  }, [dispatch, supplierStatsOverall]);

  useEffect(() => {
    setChartTransactions(
      supplierStatsOverall?.transactionStatusStats?.map((item, index) => ({
        id: index,
        value: item?.statuses?.percentage,
        label: item?.statuses?.count + " " + item?.statuses?.status,
      }))
    );
  }, [dispatch, supplierStatsOverall]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="product"
                title="Total Registered Products"
                count={
                  supplierStatsOverall?.productStats &&
                  supplierStatsOverall?.productStats?.totalProductsCount
                }
                percentage={{
                  color: "success",
                  amount:
                    supplierStatsOverall?.productStats &&
                    `+${supplierStatsOverall?.productStats?.newProductsThisMonth}`,
                  label: "new products this month",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="groups"
                title="Total Registered Clients"
                count={
                  supplierStatsOverall?.clientStats &&
                  supplierStatsOverall?.clientStats?.totalClientsCount
                }
                percentage={{
                  color: "success",
                  amount:
                    supplierStatsOverall?.clientStats &&
                    `+${supplierStatsOverall?.clientStats?.newClientsThisMonth}`,
                  label: "new clients this month",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="apartment"
                title="Total Registered Suppliers"
                count={
                  supplierStatsOverall?.supplierStats &&
                  supplierStatsOverall?.supplierStats?.totalSuppliersCount
                }
                percentage={{
                  color: "success",
                  amount:
                    supplierStatsOverall?.supplierStats &&
                    `+${supplierStatsOverall?.supplierStats?.newSuppliersThisMonth}`,
                  label: "new suppliers this month",
                }}
              />
            </MDBox>
          </Grid>
          {supplierStatsOverall?.orderStatusStats && (
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexPieStatisticsCard
                  pieData={
                    supplierStatsOverall?.orderStatusStats && chartOrders
                  }
                  icon="reorder"
                  title="Total Product Orders"
                  count={
                    supplierStatsOverall?.orderStatusStats &&
                    supplierStatsOverall?.orderStatusStats[0]?.totalCount
                  }
                  percentage={{
                    color: "success",
                    amount:
                      supplierStatsOverall?.orderStats &&
                      `+${supplierStatsOverall?.orderStats?.newOrdersThisMonth}`,
                    label: "new orders this month",
                  }}
                />
              </MDBox>
            </Grid>
          )}
          {supplierStatsOverall?.complaintStatusStats && (
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexPieStatisticsCard
                  pieData={
                    supplierStatsOverall?.complaintStatusStats &&
                    chartComplaints
                  }
                  color="success"
                  icon="approval"
                  title="Total Complaints Made"
                  count={
                    supplierStatsOverall?.complaintStatusStats &&
                    supplierStatsOverall?.complaintStatusStats[0]?.totalCount
                  }
                  percentage={{
                    color: "success",
                    amount:
                      supplierStatsOverall?.complaintStats &&
                      `+${supplierStatsOverall?.complaintStats?.newComplaintsThisMonth}`,
                    label: "new complaints this month",
                  }}
                />
              </MDBox>
            </Grid>
          )}
          {supplierStatsOverall?.transactionStatusStats && (
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexPieStatisticsCard
                  pieData={
                    supplierStatsOverall?.transactionStatusStats &&
                    chartTransactions
                  }
                  color="primary"
                  icon="receipt_long"
                  title="Total Transactions Initiated"
                  count={
                    supplierStatsOverall?.transactionStatusStats &&
                    supplierStatsOverall?.transactionStatusStats[0]?.totalCount
                  }
                  percentage={{
                    color: "success",
                    amount:
                      supplierStatsOverall?.transactionStats &&
                      `+${supplierStatsOverall?.transactionStats?.newTransactionsThisMonth}`,
                    label: "new transactions this month",
                  }}
                />
              </MDBox>
            </Grid>
          )}
        </Grid>
        <MDBox py={3}>
          <Divider />
        </MDBox>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="dark"
                  title="Clients by age"
                  description="All Clients by their age groups"
                  date="updated Now"
                  chart={chartStatsByAge}
                />
              </MDBox>
            </Grid> */}
            {clientsJoinedPerMonth && (
              <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                  <ReportsLineChart
                    color="dark"
                    title="New Clients Per Month"
                    description={<>New ProductHolders</>}
                    date="updated Now"
                    chart={clientsJoinedPerMonth}
                  />
                </MDBox>
              </Grid>
            )}
            {newOrdersPerMonth && (
              <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                  <ReportsLineChart
                    color="dark"
                    title="New Orders Per Month"
                    description="Number of orders created every month"
                    date="updated Now"
                    chart={newOrdersPerMonth}
                  />
                </MDBox>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
